import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const CompareContext = createContext();
const MAX = 3;

export function CompareProvider({ children }) {
  const [list, setList] = useState([]);

  const add = useCallback((property) => {
    setList(prev => {
      if (prev.find(p => p.property_id === property.property_id)) return prev;
      if (prev.length >= MAX) return prev;
      return [...prev, property];
    });
  }, []);

  const remove = useCallback((property_id) => {
    setList(prev => prev.filter(p => p.property_id !== property_id));
  }, []);

  const toggle = useCallback((property) => {
    setList(prev => {
      const exists = prev.find(p => p.property_id === property.property_id);
      if (exists) return prev.filter(p => p.property_id !== property.property_id);
      if (prev.length >= MAX) return prev;
      return [...prev, property];
    });
  }, []);

  const clear = useCallback(() => setList([]), []);
  const isInList = useCallback((id) => list.some(p => p.property_id === id), [list]);

  const value = useMemo(
    () => ({ list, add, remove, toggle, clear, isInList, isFull: list.length >= MAX }),
    [list, add, remove, toggle, clear, isInList]
  );

  return (
    <CompareContext.Provider value={value}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
